import React from "react";
import PartnerNavbar from "./PartnerNavbar";
import { Box } from "@mui/material";
import PartnerLeadTable from "./PartnerLeadTable";

const PartnerDashboard = ({ projectId }) => {
  const storedUser = JSON.parse(localStorage.getItem("user"));

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#F4F7FA",
        fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
        color: "#0F1B2A",
      }}
    >
      <Box className="App">
        {storedUser.userRole[0] === "PARTNER" && <PartnerNavbar />}
        {/* <Box sx={{ display: "flex" }}>
                <UserSidebar />
                <Box sx={{ px: 2, flexGrow: 1, maxWidth: "100%", overflowX: "hidden" }}>
                  <Outlet context={{ projectId }}/>
                </Box>
              </Box> */}
        <Box
          sx={{
            px: { xs: 2, sm: 3, md: 4 },
            py: { xs: 2, md: 3 },
            flexGrow: 1,
            maxWidth: 1400,
            mx: "auto",
            boxSizing: "border-box",
            width: "100%",
            overflowX: "hidden",
          }}
        >
          <PartnerLeadTable projectId={projectId} />
        </Box>
      </Box>
    </div>
  );
};

export default PartnerDashboard;
